const HSESettingsRoutes: any = {
    path: 'hse/:projectId(\\d+)?',
    name: 'hse-settings',
    component: () => import('@/views/Project/Settings/views/Hse/views/HSESettings.vue'),
    meta: {
        permission: ['hse.admin'],
        requireProject: true,
        title: 'project_menu.settings',
    },
    redirect: { name: 'hse-info-settings' },
    children: [
        {
            path: 'info',
            meta: {
                title: 'project_menu.settings',
            },
            name: 'hse-info-settings',
            component: () => import('@/views/Project/Settings/views/Hse/views/InfoSettings.vue'),
        },
        {
            path: 'qr',
            meta: {
                title: 'project_menu.settings',
            },
            name: 'hse-qr-settings',
            component: () => import('@/views/Project/Settings/views/Hse/views/QRSettings.vue'),
        },
        {
            path: 'contacts',
            meta: {
                title: 'project_menu.settings',
            },
            name: 'hse-contacts-settings',
            component: () =>
                import('@/views/Project/Settings/views/Hse/views/ContactsSettings.vue'),

            children: [
                {
                    path: 'add',
                    meta: {
                        title: 'project_menu.settings',
                    },
                    name: 'hse-add-contact',
                    component: () =>
                        import('@/views/Project/Settings/views/Hse/views/ContactAdd.vue'),
                },
                {
                    path: ':hseContactId',
                    meta: {
                        title: 'project_menu.settings',
                    },
                    name: 'hse-edit-contact',
                    component: () =>
                        import('@/views/Project/Settings/views/Hse/views/ContactEdit.vue'),
                },
            ],
        },
        {
            path: 'documents',
            meta: {
                title: 'project_menu.settings',
            },
            name: 'hse-documents-settings',
            component: () =>
                import('@/views/Project/Settings/views/Hse/views/DocumentSettings.vue'),
            children: [
                {
                    path: 'add',
                    meta: {
                        title: 'project_menu.settings',
                    },
                    name: 'hse-add-document',
                    component: () =>
                        import('@/views/Project/Settings/views/Hse/views/DocumentAdd.vue'),
                },
                {
                    path: ':hseDocumentId',
                    meta: {
                        title: 'project_menu.settings',
                    },
                    name: 'hse-edit-document',
                    component: () =>
                        import('@/views/Project/Settings/views/Hse/views/DocumentEdit.vue'),
                },
            ],
        },
    ],
}

export default HSESettingsRoutes
